
export const FETCH_ALL_BILL_RECEIVING_REQUEST = 'FETCH_ALL_BILL_RECEIVING_REQUEST';
export const FETCH_ALL_BILL_RECEIVING_SUCCESS = 'FETCH_ALL_BILL_RECEIVING_SUCCESS';
export const FETCH_ALL_BILL_RECEIVING_FAILURE = 'FETCH_ALL_BILL_RECEIVING_FAILURE';


export const FETCH_BY_ID_BILL_RECEIVING_REQUEST = 'FETCH_BY_ID_BILL_RECEIVING_REQUEST';
export const FETCH_BY_ID_BILL_RECEIVING_SUCCESS = 'FETCH_BY_ID_BILL_RECEIVING_SUCCESS';
export const FETCH_BY_ID_BILL_RECEIVING_FAILURE = 'FETCH_BY_ID_BILL_RECEIVING_FAILURE';

export const CREATE_USERFORM_BILL_RECEIVING = 'CREATE_USERFORM_BILL_RECEIVING';

export const CREATE_BILL_RECEIVING_REQUEST = 'CREATE_BILL_RECEIVING_REQUEST';
export const CREATE_BILL_RECEIVING_SUCCESS = 'CREATE_BILL_RECEIVING_SUCCESS';
export const CREATE_BILL_RECEIVING_FAILURE = 'CREATE_BILL_RECEIVING_FAILURE';

export const UPDATE_BILL_RECEIVING_REQUEST = 'UPDATE_BILL_RECEIVING_REQUEST';
export const UPDATE_BILL_RECEIVING_SUCCESS = 'UPDATE_BILL_RECEIVING_SUCCESS';
export const UPDATE_BILL_RECEIVING_FAILURE = 'UPDATE_BILL_RECEIVING_FAILURE';

export const DELETE_BILL_RECEIVING_REQUEST = 'DELETE_BILL_RECEIVING_REQUEST';
export const DELETE_BILL_RECEIVING_SUCCESS = 'DELETE_BILL_RECEIVING_SUCCESS';
export const DELETE_BILL_RECEIVING_FAILURE = 'DELETE_BILL_RECEIVING_FAILURE';

export const RESET_BILL_RECEIVING_USERFORM = 'RESET_BILL_RECEIVING_USERFORM'